import React, {Component} from 'react'
import {connect} from 'react-redux'
import {adminLogout} from '../../../actions/login'
import {doPseudoLogout} from '../../../actions/users'

class AdminLogout extends Component {
  componentWillMount() {
    const {dispatch, profile} = this.props;
    if (profile.attributes['pseudo-login']) {
      dispatch(doPseudoLogout());
    } else {
      dispatch({type: 'CLEAR_PROFILE'});
      dispatch(adminLogout());
    }
  }

  render() {
    if(this.props.processed) {
      if(this.props.profile.attributes['pseudo-login']) {
        window.location.href = `/admin/users/${this.props.profile.id}/details`;
      } else {
        window.location.href = '/admin/login';
      }
    }
    return <p>Loggin out...</p>;
  }

}

export default connect((state) => {
  return {
    processed: state.logout.processed,
    profile:   state.viewConfig.profile,
  }
})(AdminLogout);


// WEBPACK FOOTER //
// ./src/components/admin/logout/index.jsx